/* ============================================================
   Uitgeverij De Rijn — etkileşimler
   Hero slideshow · kategori sürükle-kaydır · yazar modalı
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Hero slideshow ---------- */
  function initHero(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-dr-hero-slide]'));
    if (slides.length === 0) return;
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-dr-hero-dot]'));
    var prev = root.querySelector('[data-dr-hero-prev]');
    var next = root.querySelector('[data-dr-hero-next]');
    var i = 0;
    var timer = null;
    var autoplay = root.getAttribute('data-autoplay') === 'true' && slides.length > 1;
    var speed = (parseInt(root.getAttribute('data-speed'), 10) || 6) * 1000;

    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.hidden = k !== i; });
      dots.forEach(function (d, k) {
        if (k === i) { d.setAttribute('aria-current', 'true'); }
        else { d.removeAttribute('aria-current'); }
      });
    }
    function go(n) { show(n); restart(); }
    function restart() {
      if (!autoplay) return;
      clearInterval(timer);
      timer = setInterval(function () { show(i + 1); }, speed);
    }

    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-dr-hero-dot'), 10)); });
    });
    root.addEventListener('mouseenter', function () { clearInterval(timer); });
    root.addEventListener('mouseleave', restart);

    show(0);
    restart();
  }

  /* ---------- Drag-scroll (kategori carousel) ---------- */
  function initDragScroll(el) {
    var down = false, startX = 0, startScroll = 0, moved = false;
    el.addEventListener('pointerdown', function (e) {
      down = true; moved = false; startX = e.clientX; startScroll = el.scrollLeft;
      el.classList.add('dr-dragging');
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      el.scrollLeft = startScroll - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false; el.classList.remove('dr-dragging');
    });
    el.addEventListener('click', function (e) {
      if (moved) { e.stopPropagation(); e.preventDefault(); moved = false; }
    }, true);
  }

  function initCats(wrap) {
    var track = wrap.querySelector('[data-dr-cats-track]');
    if (!track) return;
    initDragScroll(track);
    var prev = wrap.querySelector('[data-dr-cats-prev]');
    var next = wrap.querySelector('[data-dr-cats-next]');
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -560, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: 560, behavior: 'smooth' }); });
  }

  /* ---------- Yazar modalı ---------- */
  function initAuthors(section) {
    var overlay = section.querySelector('[data-dr-amodal]');
    var body = section.querySelector('[data-dr-amodal-body]');
    if (!overlay || !body) return;
    var buttons = section.querySelectorAll('[data-dr-author]');

    function open(btn) {
      var tpl = btn.querySelector('[data-dr-author-content]');
      body.innerHTML = tpl ? tpl.innerHTML : '';
      overlay.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    function close() {
      overlay.hidden = true;
      body.innerHTML = '';
      document.body.style.overflow = '';
    }

    buttons.forEach(function (b) { b.addEventListener('click', function () { open(b); }); });
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay || e.target.closest('[data-dr-amodal-close]')) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !overlay.hidden) close(); });
  }

  /* ---------- Header (dil menüsü · mega · mobil çekmece) ---------- */
  function initHeader(header) {
    // Dil açılır menüsü
    var lang = header.querySelector('[data-dr-lang]');
    if (lang) {
      var langBtn = lang.querySelector('[data-dr-lang-toggle]');
      langBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        lang.classList.toggle('is-open');
        langBtn.setAttribute('aria-expanded', lang.classList.contains('is-open'));
      });
    }
    // Mega menü (Kategoriler)
    var mega = header.querySelector('[data-dr-mega]');
    if (mega) {
      var megaBtn = mega.querySelector('[data-dr-mega-toggle]');
      megaBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        mega.classList.toggle('is-open');
        megaBtn.setAttribute('aria-expanded', mega.classList.contains('is-open'));
      });
      mega.addEventListener('mouseenter', function () { mega.classList.add('is-open'); });
      mega.addEventListener('mouseleave', function () { mega.classList.remove('is-open'); });
    }
    // Dışarı tıklayınca kapat
    document.addEventListener('click', function (e) {
      if (lang && !lang.contains(e.target)) lang.classList.remove('is-open');
      if (mega && !mega.contains(e.target)) mega.classList.remove('is-open');
    });
    // Mobil çekmece
    var drawer = header.querySelector('[data-dr-drawer]');
    if (drawer) {
      header.querySelectorAll('[data-dr-drawer-open]').forEach(function (b) {
        b.addEventListener('click', function () { drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; });
      });
      drawer.querySelectorAll('[data-dr-drawer-close]').forEach(function (b) {
        b.addEventListener('click', function () { drawer.classList.remove('is-open'); document.body.style.overflow = ''; });
      });
    }
  }

  /* ---------- Yüzen AI balonu ---------- */
  function initFloating() {
    var btn = document.querySelector('[data-dr-ai-toggle]');
    var pop = document.querySelector('[data-dr-ai-pop]');
    if (!btn || !pop) return;
    btn.addEventListener('click', function (e) { e.stopPropagation(); pop.classList.toggle('is-open'); });
    document.addEventListener('click', function (e) {
      if (!pop.contains(e.target) && !btn.contains(e.target)) pop.classList.remove('is-open');
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') pop.classList.remove('is-open'); });
  }

  /* ---------- Koleksiyon: facet auto-submit + filtre çekmecesi ---------- */
  function initCollection() {
    var form = document.querySelector('[data-dr-facets]');
    if (form) {
      form.addEventListener('change', function () {
        if (typeof form.requestSubmit === 'function') { form.requestSubmit(); }
        else { form.submit(); }
      });
    }
    var openBtn = document.querySelector('[data-dr-filters-open]');
    var filters = document.querySelector('[data-dr-filters]');
    var ov = document.querySelector('[data-dr-filters-ov]');
    if (openBtn && filters && ov) {
      function close() { filters.classList.remove('is-open'); ov.classList.remove('is-open'); document.body.style.overflow = ''; }
      openBtn.addEventListener('click', function () { filters.classList.add('is-open'); ov.classList.add('is-open'); document.body.style.overflow = 'hidden'; });
      ov.addEventListener('click', close);
    }
  }

  /* ---------- Ürün: variant seçimi · adet · thumbnail ---------- */
  function initProduct() {
    var root = document.querySelector('[data-dr-product]');
    if (!root) return;
    var dataEl = root.querySelector('[data-dr-variants]');
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var idInput = root.querySelector('[data-dr-variant-id]');
    var priceEl = root.querySelector('[data-dr-price]');
    var compareEl = root.querySelector('[data-dr-compare]');
    var saveEl = root.querySelector('[data-dr-save]');
    var addBtn = root.querySelector('[data-dr-add]');
    var addLabel = root.querySelector('[data-dr-add-label]');
    var rows = root.querySelectorAll('.dr-opt-pills');
    var mainImg = root.querySelector('[data-dr-main-cover] img');
    var buyBox = root.querySelector('[data-dr-buy]');
    var ebookBox = root.querySelector('[data-dr-ebook-buy]');
    var assurePhys = root.querySelector('[data-dr-assure-physical]');
    var assureDigi = root.querySelector('[data-dr-assure-digital]');

    function currentOptions() {
      return Array.prototype.map.call(rows, function (row) {
        var c = row.querySelector('input:checked');
        return c ? c.value : null;
      });
    }
    function sameOptions(a, b) {
      if (a.length !== b.length) return false;
      for (var i = 0; i < a.length; i++) { if (a[i] !== b[i]) return false; }
      return true;
    }
    function update() {
      // pill aktif sınıfı
      root.querySelectorAll('.dr-opt-pill').forEach(function (p) {
        var inp = p.querySelector('input');
        if (inp) p.classList.toggle('is-on', inp.checked);
      });
      var v = null;
      if (rows.length === 0) {
        // Tek varyantlı (Default Title) ürün — eşleştirmeye gerek yok
        v = variants[0];
      } else {
        var cur = currentOptions();
        for (var i = 0; i < variants.length; i++) {
          if (sameOptions(variants[i].options, cur)) { v = variants[i]; break; }
        }
      }
      if (!v) {
        if (addBtn) { addBtn.disabled = true; }
        if (addLabel) addLabel.textContent = addBtn ? (addBtn.getAttribute('data-label-unavailable') || 'Unavailable') : 'Unavailable';
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = v.price;
      if (compareEl) compareEl.style.display = v.on_sale ? '' : 'none';
      if (compareEl && v.on_sale) compareEl.textContent = v.compare_at;
      if (saveEl) saveEl.style.display = v.on_sale ? '' : 'none';
      if (addBtn) addBtn.disabled = !v.available;
      if (addLabel) {
        if (addBtn) {
          if (v.available) {
            addLabel.textContent = addBtn.getAttribute('data-label-available') || 'Add to cart';
          } else if (v.requires_shipping === false) {
            // Dijital urun (e-kitap) henuz hazir degil -> "Cok Yakinda"
            addLabel.textContent = addBtn.getAttribute('data-label-comingsoon') || addBtn.getAttribute('data-label-soldout') || 'Coming soon';
          } else {
            addLabel.textContent = addBtn.getAttribute('data-label-soldout') || 'Sold out';
          }
        } else {
          addLabel.textContent = v.available ? 'Add to cart' : 'Sold out';
        }
      }
      // Dijital varyant + e-kitap linki varsa: sepet kutusu gizlenir, D2D butonu gorunur
      if (ebookBox && buyBox) {
        var dijital = v.requires_shipping === false;
        if (dijital) { buyBox.hidden = true; ebookBox.hidden = false; }
        else { buyBox.hidden = false; ebookBox.hidden = true; }
      }
      if (mainImg && v.featured_image) { mainImg.removeAttribute('srcset'); mainImg.src = v.featured_image; }
      if (assurePhys && assureDigi) {
        if (v.requires_shipping) {
          assurePhys.removeAttribute('hidden');
          assurePhys.style.display = '';
          assureDigi.setAttribute('hidden', 'hidden');
          assureDigi.style.display = 'none';
        } else {
          assurePhys.setAttribute('hidden', 'hidden');
          assurePhys.style.display = 'none';
          assureDigi.removeAttribute('hidden');
          assureDigi.style.display = '';
        }
      }

      if (v.options && v.options.length) {
        v.options.forEach(function (optVal, idx) {
          var specVal = root.querySelector('[data-dr-spec-val="' + idx + '"]');
          if (specVal) specVal.textContent = optVal;
        });
      }
    }

    root.querySelectorAll('[data-dr-opt]').forEach(function (r) {
      r.addEventListener('change', update);
    });

    // adet
    var qty = root.querySelector('[data-dr-qty]');
    var minus = root.querySelector('[data-dr-qty-minus]');
    var plus = root.querySelector('[data-dr-qty-plus]');
    if (qty && minus && plus) {
      minus.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
      plus.addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; });
    }

    // thumbnail değiştir (hover + tıklama)
    function setMain(t) {
      if (mainImg) { mainImg.removeAttribute('srcset'); mainImg.src = t.getAttribute('data-dr-thumb'); }
      root.querySelectorAll('.dr-pdp__thumb').forEach(function (x) { x.classList.remove('is-active'); });
      t.classList.add('is-active');
    }
    root.querySelectorAll('[data-dr-thumb]').forEach(function (t) {
      t.addEventListener('mouseenter', function () { setMain(t); });
      t.addEventListener('click', function () { setMain(t); });
    });

    // video thumbnail → modal
    var vmodal = document.querySelector('[data-dr-vmodal]');
    var vbody = document.querySelector('[data-dr-vmodal-body]');
    function openVideo(idx) {
      var tpl = root.querySelector('[data-dr-video-tpl="' + idx + '"]');
      if (!tpl || !vmodal || !vbody) return;
      vbody.innerHTML = tpl.innerHTML;
      vmodal.hidden = false;
      document.body.style.overflow = 'hidden';
      var vid = vbody.querySelector('video');
      if (vid) { try { vid.play(); } catch (e) {} }
    }
    function closeVideo() {
      if (!vmodal) return;
      vmodal.hidden = true;
      vbody.innerHTML = '';
      document.body.style.overflow = '';
    }
    root.querySelectorAll('[data-dr-video]').forEach(function (t) {
      t.addEventListener('click', function () { openVideo(t.getAttribute('data-dr-video')); });
    });
    if (vmodal) {
      vmodal.querySelectorAll('[data-dr-vmodal-close]').forEach(function (b) { b.addEventListener('click', closeVideo); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeVideo(); });
    }

    update();
  }

  function initAll() {
    initFloating();
    initCollection();
    initProduct();
    document.querySelectorAll('.dr-hdr').forEach(initHeader);
    document.querySelectorAll('[data-dr-hero]').forEach(initHero);
    document.querySelectorAll('[data-dr-cats]').forEach(initCats);
    document.querySelectorAll('[data-dr-drag]').forEach(initDragScroll);
    document.querySelectorAll('[data-dr-authors]').forEach(initAuthors);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor: bölüm yeniden yüklenince tekrar bağla
  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target;
    if (t.querySelector && t.querySelector('[data-dr-ai-toggle]')) initFloating();
    t.querySelectorAll('.dr-hdr').forEach(initHeader);
    t.querySelectorAll('[data-dr-hero]').forEach(initHero);
    t.querySelectorAll('[data-dr-cats]').forEach(initCats);
    t.querySelectorAll('[data-dr-drag]').forEach(initDragScroll);
    t.querySelectorAll('[data-dr-authors]').forEach(initAuthors);
  });
})();

/* ---- De Rijn AI Asistan sohbeti ---- */
(function () {
  function init() {
    var pop = document.querySelector('[data-dr-ai-pop]');
    if (!pop) return;
    var endpoint = pop.getAttribute('data-dr-ai-endpoint');
    var kapat = pop.querySelector('[data-dr-ai-close]');
    if (kapat) kapat.addEventListener('click', function () { pop.classList.remove('is-open'); });

    if (!endpoint) return; // servis adresi yoksa eski "cok yakinda" hali

    var log = pop.querySelector('[data-dr-ai-log]');
    var form = pop.querySelector('[data-dr-ai-form]');
    var input = pop.querySelector('[data-dr-ai-input]');
    var send = pop.querySelector('[data-dr-ai-send]');
    if (!log || !form || !input) return;

    var gecmis = [];

    function ekle(metin, kim) {
      var d = document.createElement('div');
      d.className = 'dr-ai-msg dr-ai-msg--' + kim;
      d.textContent = metin;
      log.appendChild(d);
      log.scrollTop = log.scrollHeight;
      return d;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var soru = (input.value || '').trim();
      if (!soru) return;
      input.value = '';
      ekle(soru, 'user');
      gecmis.push({ role: 'user', content: soru });
      if (gecmis.length > 8) gecmis = gecmis.slice(-8);

      var bekle = ekle('…', 'bot');
      bekle.classList.add('is-typing');
      if (send) send.disabled = true;

      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ messages: gecmis }),
      })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          bekle.classList.remove('is-typing');
          var cevap = d && d.reply ? d.reply : (pop.getAttribute('data-dr-ai-error') || 'Şu an yanıt veremiyorum, lütfen WhatsApp\'tan yazın.');
          bekle.textContent = cevap;
          if (d && d.reply) gecmis.push({ role: 'assistant', content: d.reply });
          log.scrollTop = log.scrollHeight;
        })
        .catch(function () {
          bekle.classList.remove('is-typing');
          bekle.textContent = pop.getAttribute('data-dr-ai-error') || 'Bağlantı kurulamadı, lütfen WhatsApp\'tan yazın.';
        })
        .finally(function () { if (send) send.disabled = false; input.focus(); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
